import React from "react";

interface OwnProps {
  phonenumber: string | undefined;
}

type Props = OwnProps;

export default class PhoneNumberDisplay extends React.PureComponent<Props> {
  private isInvalid: boolean;
  private phoneNumber: string;

  constructor(props: Props) {
    super(props);
    this.phoneNumber = this.props.phonenumber ? this.props.phonenumber.replace(/[^0-9]/g, "") : "";
    this.isInvalid = this.phoneNumber.length != 10;
  }

  private getFormattedPhoneNumber() {
    return (
      "(" +
      this.phoneNumber.substring(0, 3) +
      ") " +
      this.phoneNumber.substring(3, 6) +
      "-" +
      this.phoneNumber.substring(6, 10)
    );
  }

  public render() {
    return (
      <>
        {this.isInvalid ? (
          <span className="red">Invalid</span>
        ) : (
          <span>{this.getFormattedPhoneNumber()}</span>
        )}
      </>
    );
  }
}
